// extracted by mini-css-extract-plugin
module.exports = {"CountData_container":"CountData_CountData_container__yttv4"};